// removed by extract-text-webpack-plugin
module.exports = {"calendar-side-bar":"calendar-side-bar","side-bar-overlay":"side-bar-overlay","side-bar-content":"side-bar-content","visible":"visible"};


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/authorized/scene/calendar/component/calendar-side-bar/calendar-side-bar.style.sass
// module id = WXo7
// module chunks = 0